import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import checkmark from '../../images/checkmark.svg';
import styles from '../../styles/FormRadioListInput.module.scss';

const cx = classNames.bind(styles);

const EnrollmentFormRadioListInput = ({ name, id, label, value, defaultValue, inputRef, onClick, hidden }) => {
  return (
    <label htmlFor={id} className={cx(styles.EnrollmentFormRadioListInput, { hidden })}>
      <input
        name={name}
        id={id}
        type="radio"
        value={value}
        defaultChecked={defaultValue === value}
        ref={inputRef}
        onClick={onClick}
      />
      <img className={styles.checkmark} alt="Selected" src={checkmark} />
      <div className={styles.emptyCheckmark} />
      <span className={styles.option}>{label}</span>
      <div className={styles.checkedBackground} />
    </label>
  );
};

EnrollmentFormRadioListInput.defaultProps = {
  defaultValue: null,
  onClick: null,
  hidden: false,
};

EnrollmentFormRadioListInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  inputRef: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
};

export default EnrollmentFormRadioListInput;
